import { render } from "./PurchasingFund.vue?vue&type=template&id=4b4f39ce&scoped=true"
import script from "./PurchasingFund.vue?vue&type=script&lang=js"
export * from "./PurchasingFund.vue?vue&type=script&lang=js"

import "./PurchasingFund.vue?vue&type=style&index=0&id=4b4f39ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4f39ce"]])

export default __exports__